var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-single"},[(_vm.isBundle)?[_c('ProductCombo',{attrs:{"item":_vm.single}})]:[_c('Product',{attrs:{"item":_vm.single}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }